import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';

import { DepositeInventoryStatusesListModel } from '../../models/deposite/depositeInventoryStatuses';
import { DepositeSearchModel } from '../../models/deposite/depositeSearch';
import * as DepositeModels from '../../models/deposite/deposite';
import * as Models from '../../models/commonModels';
import * as OrderModels from '../../models/order/order';

import { DepositeInventoryNote, DepositeInventoryNoteListModel } from '../../models/deposite/depositeInventoryNote';
import { DepositeInventoryNoteSearchModel } from '../../models/deposite/depositeInventoryNoteSearch';
import { EnvironmentService } from '../../../app/services/environment.service';


@Injectable({
  providedIn: 'root'
})
export class DepositeService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getList(Search: DepositeSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    Search.RequestSignature = Math.random();

    return this.httpClient.post<DepositeModels.DepositeListModel>(`${this.environmentService.getApiURL()}/deposite/list`, Search, options);
  }

  public get(Deposite: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DepositeModels.DepositeModel>>(`${this.environmentService.getApiURL()}/deposite/get`, Deposite, options);
  }

  public getPreviewList(Search: DepositeSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    Search.RequestSignature = Math.random();

    return this.httpClient.post<DepositeModels.DepositePreviewListModel>(`${this.environmentService.getApiURL()}/deposite/preview-list`, Search, options);
  }

  public getDepositeInventoryStatuses() {
    return this.httpClient.get<DepositeInventoryStatusesListModel>(`${this.environmentService.getApiURL()}/deposite/deposite-inventory-status`);
  }

  public set(Deposite: Models.Request<DepositeModels.DepositeModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DepositeModels.DepositeModel>>(`${this.environmentService.getApiURL()}/deposite/set`, Deposite, options);
  }

  public setInventory(Deposite: Models.Request<DepositeModels.DepositeModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DepositeModels.DepositeModel>>(`${this.environmentService.getApiURL()}/deposite/set-inventory`, Deposite, options);
  }

  public setList(Deposites: Models.RequestNewOrder<DepositeModels.DepositePreviewModel[]> ) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<DepositeModels.DepositePreviewListModel>(`${this.environmentService.getApiURL()}/deposite/set-list`, Deposites, options);
  }

  public getReport(Search: DepositeSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/deposite/report`, Search, options);
  }

  public getInventoryReport(Search: DepositeSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/deposite/report-inventory`, Search, options);
  }

  public getReportAgregated(Search: DepositeSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/deposite/report-agregated`, Search, options);
  }

  public getReportAgregatedExtended(Search: DepositeSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/deposite/report-agregated-extended`, Search, options);
  }

  public getReportUtilization(Search: DepositeSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/deposite/report-utilization`, Search, options);
  }

  public getDepositeInventoryNote(Search: DepositeInventoryNoteSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<DepositeInventoryNoteListModel>(`${this.environmentService.getApiURL()}/deposite-inventory-note/list`, Search, options);
  }

  public getLastReturned(Search: DepositeSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    Search.RequestSignature = Math.random();

    return this.httpClient.post<DepositeModels.DepositeListModel>(`${this.environmentService.getApiURL()}/deposite/list`, Search, options);
  }

  public getPdf(Search: DepositeSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/deposite/pdf`, Search, options);
  }

  public importAgregatedExtended(Data: any) {

    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' };

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/deposite/import-agregated-extended`, Data, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }


  public resetInventory(Deposite: Models.Request<DepositeModels.DepositeModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<DepositeModels.DepositeModel>>(`${this.environmentService.getApiURL()}/deposite/reset-inventory`, Deposite, options);
  }

  public setInventoryList(Search: DepositeSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    Search.RequestSignature = Math.random();

    return this.httpClient.post<DepositeModels.DepositeListModel>(`${this.environmentService.getApiURL()}/deposite/set-inventory-list`, Search, options);
  }

  public setPickupCalls(Request: Models.ContextRequest<OrderModels.OrderPreviewModel[], Date>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<DepositeModels.DepositePreviewListModel>(`${this.environmentService.getApiURL()}/deposite/set-pickup-calls`, Request, options);
  }
}


